<template>
  <div class="layout-box">
    <LayoutHeader headtitle="专业资讯"></LayoutHeader>
    <div class="secondary-content">
      <div class="news-list">
        <span class="news-list-tit"><i class="iconfont icon-xinwen1"></i>资讯列表</span>
        <ul>
          <li v-for="(item,index) in datas" :key="index" :class="ids==(item.id)?'on':''" @click="getnewdetail(item.id)"><em>{{ index+1 }}</em><a>{{item.title}}</a></li>
        </ul>
      </div>
      <GoBack v-if="isgoback"></GoBack>
      <div class="new-detail">
        <div class="new-detail-title" v-if="titles">{{ titles }}</div>
        <p class="new-detail-time" v-if="times">{{ times }}</p>
        <div class="new-detail-content" v-if="content">
          <div class="newscontent" v-html="content"></div>
          <div class="newscontent" v-if="srcList.length>0" style="padding-top: 0; display: flex; justify-content: space-around">
            <el-image
              v-for="(item,index) in srcList"
              :key="index"
              style="width: 302px; height: 302px"
              :src="item"
              fit="cover"
              :preview-src-list="srcList"
            />
          </div>
          <div class="watermark" v-if="srcList.length<=0"></div>
        </div>
        <div style="background: #fff; text-align: center; padding: 22px 0; font-size: 18px;" v-if="priceStatus>0">该文章需要购买才能完整阅读!</div>
        <div style="background: #fff; height: 450px" v-if="isnull"><el-empty description="未获取到文章哦"></el-empty></div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'SearchIndex',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      titles:'',
      times:'',
      content:'',
      isnull:false,
      isgoback:false,
      priceStatus:0, //文章状态 0 正常显示 1 付费 2 买vip
      ids:0,
      datas:[],
      srcList:[]
    }
  },
  created() {
    this.$nextTick(()=>{
      document.oncontextmenu= new Function("event.returnValue=false")
      document.onselectstart= new Function("event.returnValue=false")
    })
    this.ids=this.$route.query.id
    if(this.ids){
      this.getnewdetail(this.ids)
    }else {
      this.isnull=true
    }
    const url = '/api-portal/article/articleList';
    this.$api.post(url, {title:'',pageNum:1,pageSize:20}, (response) => {
      let datas=response.data||''
      if(datas.data){
        this.datas=datas.data.records
      }
      this.cutnew()
    },'json');
  },
  methods: {
    getnewdetail(ids){
      const url = '/api-portal/article/articleInfo';
      this.$api.get(url, {id:ids}, (response) => {
        let datas=response.data||''
        this.ids=ids
        if(datas.data){
          this.titles=datas.data.title
          this.times=datas.data.createtime
          this.content=datas.data.content
          this.priceStatus=datas.data.priceStatus || 0
          if(datas.data.articletype == 1&&datas.data.url){
            this.srcList=(datas.data.url).split(',')
          }else {
            this.srcList=[]
          }
        }else {
          this.isnull=true
        }
      },'json')
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
  min-height: calc(100% - 20px);
}

.gotob{
  width: 49px;
  height: 40px;
  padding-left: 35px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: #0B42AF;
  position: absolute;
  right: 0;
  top:-40px;
  font-size: 16px;
  color: #DBE1F1;
  line-height: 40px;
  cursor: pointer;
  background-image: url("../../assets/goto.fw.png");
  background-repeat: no-repeat;
  background-position: 9px 10px;
}

.gotob:hover{
  text-shadow: 2px 2px 4px rgba(0,0,0,.4);
  background-color: #0B3999;
}

.new-detail{
  padding: 30px 48px;
  width: calc(100% - 96px);
  height: calc(100% - 60px);
  user-select: none;
}

.new-detail-title{
  font-size: 24px;
  width: 100%;
  text-align: center;
  line-height: 32px;
  min-height: 32px;
  padding: 12px 0 20px 0;
  border-bottom: 1px solid #4F8EF9;
  color: #FFFFFF;
}

.new-detail-time{
  width: 100%;
  text-align: center;
  color: #A6C6FC;
  font-size: 14px;
  margin-top: 12px;
}

.new-detail-content{
  width: 100%;
  font-size: 16px;
  background: #fff;
  color: #333;
  line-height: 217%;
  margin-top: 40px;
  box-sizing: border-box;
  position: relative;
}

.newscontent{
  background: url("../../assets/watermark.png") repeat;
  padding: 20px 30px;
}

.watermark{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/watermark.png") repeat;
}

.news-list{
  width: 270px;
  position: fixed;
  height: calc(100% - 190px);
  top: 170px;
  left: 50%;
  margin-left: -840px;
  background: #0A47B6;
  overflow: auto;
}

.news-list::-webkit-scrollbar{
  display: none;
}

.news-list-tit{
  background: #fff;
  display: block;
  width: calc(100% - 40px);
  color: #0A47B6;
  margin: 12px auto;
  font-size: 16px;
  line-height: 32px;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 6px;
  box-shadow: 1px 4px 8px 0 rgba(0,0,0,.2);
}

.news-list-tit i{
  font-size: 24px;
  display: inline-block;
  vertical-align: top;
  margin-right: 7px;
  margin-top: -1px;
}

.news-list em{
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  color: #0A47B6;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  margin-right: 5px;
  vertical-align: top;
  margin-top: 1px;
}

.news-list .on{
  background: #07358B;
  border-radius: 6px;
}

.news-list a{
  color: #fff;
  width: calc(100% - 26px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  cursor: pointer;
}

.news-list a:hover{
  text-decoration: underline;
}

.news-list ul{
  margin: 5px 20px;
  position: relative;
}

.news-list li{
  padding: 10px 0 10px 5px;
}

</style>




// WEBPACK FOOTER //
// src/views/secondary/secondary-new-details.vue